'use client';

import React, { useEffect } from 'react';
import { TemplateLoader } from '@/components/TemplateLoader';
import { HomeContentComponent } from '@/templates';

function Home() {
  useEffect(() => {
    // Only clear session-specific data
    sessionStorage?.removeItem('seatData');
    sessionStorage?.removeItem('ssrInfoData');
    sessionStorage.removeItem('reqData');
    // Do not clear sessionStorage city data
  }, []);

  // useEffect(() => {
  //   fetch(`/${config?.corporateName}/customarReview.json`)
  //     .then((res) => res.json())
  //     .then((data) => setReviews(data?.data || []))
  //     .catch((err) => {
  //       console.error('Failed to load reviews:', err);
  //       setReviews([]); // fallback to empty array
  //     });
  // }, []);

  return (
    <TemplateLoader>
      {/* <NavbarComponent /> */}
      {/* <HeaderComponent /> */}
      {/* Template content will be rendered here after theme initialization */}
      <HomeContentComponent />
      {/* {process.env.NODE_ENV === 'development' && <TemplateTest />} */}
      {/* <BodyElementChecker /> */}
    </TemplateLoader>
  );
}

export default Home;
